import * as React from 'react';

export const AdvanceNoRocket = ({
  sectionName,
  ttlName,

  container,
  colCustomize,
  blockName,

  yearsTxt,
  pplCountTxt,
  pplCoursesTxt,
  reviewsTxt,

  numbersType = 'numbers',
}) => {
  return (
    <section className={sectionName}>
      <div className="container">
        <h2 className={ttlName}>Мы – центр образовательных технологий advance</h2>

        <AdvanceCounts
          container={container}
          colCustomize={colCustomize}
          blockName={blockName}
          yearsTxt={yearsTxt}
          pplCoursesTxt={pplCoursesTxt}
          pplCountTxt={pplCountTxt}
          reviewsTxt={reviewsTxt}
          numbersType={numbersType}
        />
      </div>
    </section>
  );
};

export const AdvanceCounts = ({
  container,
  colCustomize,
  blockName,

  yearsTxt,
  pplCountTxt,
  pplCoursesTxt,
  reviewsTxt,

  numbersType, // "numbers" for numbers, "text" for text
}) => {
  return (
    <div className={container ? container : 'row'}>
      <div className={colCustomize}>
        <div className={blockName}>
          <h3>С 2009 года</h3>
          <p>{yearsTxt ? yearsTxt : 'занимаемся развитием личной эффективности'}</p>
        </div>
      </div>

      <div className={colCustomize}>
        <div className={blockName}>
          <h3>{numbersType === 'numbers' ? '1\u00A0700\u00A0000' : '1,7\u00A0млн'}</h3>
          <p>{pplCountTxt ? pplCountTxt : 'человек посетили наши пробные уроки и\u00A0семинары'}</p>
        </div>
      </div>

      <div className={colCustomize}>
        <div className={blockName}>
          <h3>{numbersType === 'numbers' ? '85\u00A0000' : '85\u00A0тыс'}</h3>
          <p>{pplCoursesTxt ? pplCoursesTxt : 'человек прошли наши полные программы'}</p>
        </div>
      </div>

      <div className={colCustomize}>
        <div className={blockName}>
          <h3>{numbersType === 'numbers' ? '32\u00A0000' : '32\u00A0тыс'}</h3>
          <p>{reviewsTxt ? reviewsTxt : 'отзывов'}</p>
        </div>
      </div>
    </div>
  );
};
